export var INIT = 0;
export var REJECTED = 1;
export var CONFIRMED = 2;
export var CALCULATED = 3;
export var CASHOUT = 4;
export var BET_PAY_REQUEST = 5;
export var IN_DELAY = 6;
export var STAKE_REQUEST = 7;
export var CONFIRM_AWAIT = 8;



// WEBPACK FOOTER //
// ./src/constants/BetStatus.js